import React, { Component } from 'react';
import Plx from 'react-plx';

import './WeDo.css';
import { speed } from '../Config';

import Movie from './Drawings/Movie';
import Ad from './Drawings/Ad';
import Series from './Drawings/Series';

const wrapper = [
  {
    start: `${6.75 * speed}vh`,
    end: `${9.5 * speed}vh`,
    easing: [0.25, 0.1, 0.6, 1.5],
    properties: [
      {
        startValue: 30,
        endValue: 0,
        unit: 'vh',
        property: 'translateY',
      },
      {
        startValue: 0,
        endValue: 1,
        property: 'opacity',
      },
    ]
  },
  {
    start: `${13.5 * speed}vh`,
    end: `${16 * speed}vh`,
    easing: [0.25, 0.1, 0.6, 1.5],
    properties: [
      {
        startValue: 0,
        endValue: -30,
        unit: 'vh',
        property: 'translateY',
      },
      {
        startValue: 1,
        endValue: 0,
        property: 'opacity',
      },
    ]
  },
];

const inner = [
  {
    start: `${9.25 * speed}vh`,
    end: `${10.5 * speed}vh`,
    properties: [
      {        
        startValue: 0,
        endValue: -80,
        property: 'translateY',
      },
    ]
  },
  {
    start: `${11.5 * speed}vh`,
    end: `${13 * speed}vh`,
    properties: [
      {        
        startValue: -80,
        endValue: -160,
        property: 'translateY',
      },
    ]
  },
];

export class WeDo extends Component {
  render() {
    return (
      <Plx
        parallaxData={wrapper}
        className="we-wrapper"
      >
        <div className="we-inner" >
          <p className="we-top" >AGRON</p>
          <div className="we-middle" >
            <Plx
               parallaxData={inner}
               className="we-middle-inner"
            >
              <div className="we-film" >
                <p className="we-middle-text" >
                  Film
                </p>
              </div>
              <div className="we-series" >
                <p className="we-middle-text" >
                  Dizi
                </p>
              </div>
              <div className="we-add" >
                <p className="we-middle-text" >
                  Reklam
                </p>
              </div>
            </Plx>
          </div>
          <div className="we-icon-wrapper" >
          <Plx
            className="we-icon-item"
          >
            <Movie
              className="we-icon"
            />
          </Plx>
          <Plx
            className="we-icon-item"
          >
            <Series
              className="we-icon"
            />
          </Plx>
          <Plx
            className="we-icon-item"
          >
            <Ad
              className="we-icon"
            />
          </Plx>
          </div>
        </div>
      </Plx>
    );
  };
};

export default WeDo
